import {
  createContext,
  useContext,
  useReducer,
  useEffect,
  useState,
} from "react";
import { useLocation, useParams } from "react-router";
import { useSelector } from "react-redux";
import coursereducer from "../reducer/CourseReducer";
import { useAuth } from "../features/auth/AuthContext";
import api from "../api/api";
import { fetchStudents } from "../state/actions/getEnrolledCoursesDataAction";

const CourseContext = createContext();

export const CourseContextProvider = ({ children }) => {
  const initialFilterState = {
    filter_data: [],
    all_data: [],
    total: 0,
    loading: false,
    error: false,
    errormsg: "",
    filters: {},
    extra_data: {},
  };
  const [state, dispatch] = useReducer(coursereducer, initialFilterState);
  const students = useSelector(
    (state) => state.EnrolledCourseData?.students || [],
  );

  const studentNames = students.map((s) => s.student_name);
  const studentGrades = students.map((s) => s.student_grade);

  const studentName = studentNames.join(",");
  const studentGrade = studentGrades.join(",");
  
  const location = useLocation();

  const locationState = location.state;
  const { token } = useAuth();

  const globalState = useSelector((state) => state.globalState);
  const roleFromState = location.state?.role;
  // const roleType =roleFromState|| globalState?.teacher_details?.data?.teacher_department_roles;
  // const is_ls_advisor = roleType === "learning specialist" || roleType === "advisor";
  // In CourseContext.js — add this:
// const locationState = location.state;
const roleFromLocation = locationState?.roleFromState ?? null;  // ← ADD

// Then use it:
const roleType = globalState?.teacher_details?.data?.teacher_department_roles;
const is_ls_advisor = 
  roleType?.toLowerCase() === "learning specialist" || 
  roleType?.toLowerCase() === "advisor" ||
  roleFromLocation?.toLowerCase() === "learning specialist" ||  // ← ADD fallback
  roleFromLocation?.toLowerCase() === "advisor";

console.log("fromsatte", roleFromLocation);   // ← your existing log
console.log("roleType", roleType);

  console.log(is_ls_advisor, "is ls adv");
  console.log(roleFromState, "fromsatte")
  console.log(roleType, "roleType")
  const updateLessionFilter = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    return dispatch({
      type: "UPDATE_LESSION_FILTER",
      payload: { name, value },
    });
  };
  const getLessionProgress = async () => {
    dispatch({ type: "SET_LOADING" });
    let lessonId = locationState?.lesson?.lesson_id;
    api
      .get(
        `/lessons/get-lesson-status/` +
          lessonId +
          `/?teacher_id=${locationState.teacher_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data.count > 0) {
            dispatch({
              type: "SET_API_DATA",
              payload: response?.data?.data ?? [],
            });
          } else {
            dispatch({
              type: "API_ERROR",
              errormsg: response?.message?.message ?? "No Record Found",
            });
          }
        } else {
          dispatch({
            type: "API_ERROR",
            errormsg: response?.message?.message ?? "Something went wrong",
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "API_ERROR", errormsg: error });
      });
  };
  const getLessionAssignmentsProgress = async () => {
    dispatch({ type: "SET_LOADING" });
    let assignmentId = locationState?.assignment?.assignment_id
      ? locationState?.assignment?.assignment_id
      : locationState?.assignment_id;

    api
      .get(
        `/assignments/assignmentresultsearch/V2/?page=1&assignment_id=${assignmentId}&student__name=${studentName}&grade=${studentGrade}&result=&sorting=Newest&is_ls_advisor=${is_ls_advisor}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        },
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data.length > 0) {
            dispatch({
              type: "SET_API_DATA",
              payload: response?.data?.data ?? [],
            });
          } else {
            dispatch({
              type: "API_ERROR",
              errormsg: response?.message?.message ?? "No Record Found",
            });
          }
        } else {
          dispatch({
            type: "API_ERROR",
            errormsg: response?.message?.message ?? "Something went wrong",
          });
        }
      })
      .catch((error) => {
        dispatch({ type: "API_ERROR", errormsg: error });
      });
  };

  useEffect(() => {
    if (locationState?.tabValue == "assignments") {
      getLessionAssignmentsProgress();
    } else if (locationState?.tabValue == "lessons") {
      getLessionProgress();
    }
  }, []);

  return (
    <CourseContext.Provider
      value={{
        ...state,
        updateLessionFilter,
      }}
    >
      {children}
    </CourseContext.Provider>
  );
};

export const useCourseContext = () => {
  return useContext(CourseContext);
};
